const translations = {
  en: {
    // Navigation
    'nav.services': 'Services',
    'nav.about': 'About Us',
    'nav.blog': 'Blog',
    'nav.careers': 'Careers',
    'nav.contact': 'Contact',

    // Hero
    'hero.title': "Shaping Tomorrow's",
    'hero.subtitle': 'Digital Reality',
    'hero.description': "At EDNX, we're not just building technology – we're crafting the future. Our vision combines cutting-edge AI with human creativity to transform how businesses and people interact with technology.",
    'hero.cta.start': 'Start Your Journey',
    'hero.cta.demo': 'Watch Demo',

    // Services
    'services.title': 'Our Solutions',
    'services.subtitle': 'Empowering your business with cutting-edge technology solutions',
    'services.description': 'Discover how our innovative solutions can transform your business and drive growth.',
    'services.explore': 'Explore Our Services',
    'services.start': 'Get Started',

    // Stats
    'stats.clients': 'Happy Clients',
    'stats.success': 'Success Rate',
    'stats.projects': 'Projects Delivered',
    'stats.solutions': 'AI Solutions',

    // Testimonials
    'testimonials.title': 'What Our Clients Say',
    'testimonials.readMore': 'Read More',

    // Globe Section
    'globe.title': 'Global Innovation Hub',
    'globe.description': "From our headquarters to every corner of the globe, we're connecting innovators, technologies, and ideas to shape a better future.",
    'globe.support': 'Global Support',
    'globe.countries': 'Countries Served',

    // Contact Form
    'contact.title': 'Ready to Transform Your Vision?',
    'contact.description': "Let's create something extraordinary together. Your innovation journey starts here.",
    'contact.form.name': 'Name',
    'contact.form.email': 'Email',
    'contact.form.company': 'Company',
    'contact.form.projectType': 'Project Type',
    'contact.form.budget': 'Budget Range',
    'contact.form.timeline': 'Expected Timeline',
    'contact.form.description': 'Project Description',
    'contact.form.submit': 'Send Message',
    'contact.form.required': '* Required fields',
    'contact.success.title': 'Thank You!',
    'contact.success.message': "We've received your message and will get back to you within 24 hours.",
    'contact.success.another': 'Send another message',

    // Footer
    'footer.tagline': 'Empowering the future of technology, rooted in human nature.',
    'footer.services': 'Services',
    'footer.company': 'Company',
    'footer.connect': 'Connect',
    'footer.legal': 'Legal',
    'footer.rights': 'All rights reserved.'
  },
  de: {
    // Navigation
    'nav.services': 'Dienstleistungen',
    'nav.about': 'Über uns',
    'nav.blog': 'Blog',
    'nav.careers': 'Karriere',
    'nav.contact': 'Kontakt',

    // Hero
    'hero.title': 'Gestalten der',
    'hero.subtitle': 'Digitalen Realität von Morgen',
    'hero.description': 'Bei EDNX entwickeln wir nicht nur Technologie – wir gestalten die Zukunft. Unsere Vision verbindet modernste KI mit menschlicher Kreativität, um die Art und Weise zu transformieren, wie Unternehmen und Menschen mit Technologie interagieren.',
    'hero.cta.start': 'Starten Sie Ihre Reise',
    'hero.cta.demo': 'Demo ansehen',

    // Services
    'services.title': 'Unsere Lösungen',
    'services.subtitle': 'Stärkung Ihres Unternehmens mit modernsten Technologielösungen',
    'services.description': 'Entdecken Sie, wie unsere innovativen Lösungen Ihr Unternehmen transformieren und Wachstum fördern können.',
    'services.explore': 'Entdecken Sie unsere Dienste',
    'services.start': 'Jetzt starten',

    // Stats
    'stats.clients': 'Zufriedene Kunden',
    'stats.success': 'Erfolgsquote',
    'stats.projects': 'Abgeschlossene Projekte',
    'stats.solutions': 'KI-Lösungen',

    // Testimonials
    'testimonials.title': 'Was unsere Kunden sagen',
    'testimonials.readMore': 'Mehr lesen',

    // Globe Section
    'globe.title': 'Globaler Innovationshub',
    'globe.description': 'Von unserem Hauptsitz bis in jeden Winkel der Welt verbinden wir Innovatoren, Technologien und Ideen, um die Zukunft zu gestalten.',
    'globe.support': 'Globaler Support',
    'globe.countries': 'Betreute Länder',

    // Contact Form
    'contact.title': 'Bereit, Ihre Vision zu verwirklichen?',
    'contact.description': 'Lassen Sie uns gemeinsam etwas Außergewöhnliches schaffen. Ihre Innovationsreise beginnt hier.',
    'contact.form.name': 'Name',
    'contact.form.email': 'E-Mail',
    'contact.form.company': 'Unternehmen',
    'contact.form.projectType': 'Projektart',
    'contact.form.budget': 'Budget',
    'contact.form.timeline': 'Erwarteter Zeitrahmen',
    'contact.form.description': 'Projektbeschreibung',
    'contact.form.submit': 'Nachricht senden',
    'contact.form.required': '* Pflichtfelder',
    'contact.success.title': 'Vielen Dank!',
    'contact.success.message': 'Wir haben Ihre Nachricht erhalten und werden uns innerhalb von 24 Stunden bei Ihnen melden.',
    'contact.success.another': 'Weitere Nachricht senden',

    // Footer
    'footer.tagline': 'Wir gestalten die Zukunft der Technologie, verwurzelt in der menschlichen Natur.',
    'footer.services': 'Dienstleistungen',
    'footer.company': 'Unternehmen',
    'footer.connect': 'Verbinden',
    'footer.legal': 'Rechtliches',
    'footer.rights': 'Alle Rechte vorbehalten.'
  }
} as const;

export default translations;